// ** MUI Imports
import Button from '@mui/material/Button'
import Drawer from '@mui/material/Drawer'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
// ** Types
import { SidebarLeftType, CalendarFiltersType } from 'src/types/apps/calendarTypes'
import { useEffect, useState } from 'react'
import { ChannelType, channelDefault } from 'src/types/apps/channelTypes'

const SidebarLeft = (props: SidebarLeftType) => {
  const {
    rootStore,
    store,
    mdAbove,
    dispatch,
    calendarsColor,
    leftSidebarOpen,
    leftSidebarWidth,
    handleSelectEvent,
    handleAllCalendars,
    handleCalendarsUpdate,
    handleChannelUpdate,
    handleLeftSidebarToggle,
    handleAddEventSidebarToggle,
    setShowPostContentDialog
  } = props

    const [isDefaultOrgActive, setIsDeafultOrgActive] = useState<boolean>(false); 
    const [availableChannels, setAvailableChannels] = useState<ChannelType[]>(channelDefault);

    useEffect(() => {
        if (rootStore.lookup.data.userOrgChannels) {
            let isDefaultOrgActive = rootStore.lookup.data.userOrgChannels.organizations.some((uc) => uc.active && uc.isDefaultOrg);
            setIsDeafultOrgActive(isDefaultOrgActive);
            if (!isDefaultOrgActive) {
                let currentOrg = rootStore.lookup.data.userOrgChannels.organizations.filter((uc) => uc.active)[0];
                setAvailableChannels(currentOrg.channels);
            }
            else {
                setAvailableChannels(rootStore.channel.data);
            }
        }
    }, [rootStore.channel.data, rootStore.lookup.data.userOrgChannels]);

  const colorsArr = calendarsColor ? Object.entries(calendarsColor) : []

  const renderFilters = colorsArr.length
    ? colorsArr.map(([key, value]: string[]) => {
        return (
          <FormControlLabel
            key={key}
            label={key}
            sx={{ mb: 0.5 }}
            control={
              <Checkbox
                checked={store.selectedCalendars.includes(key as CalendarFiltersType)}
                onChange={() => dispatch(handleCalendarsUpdate(key as CalendarFiltersType))}
                sx={{ color: `${value}.main`, '&.Mui-checked': { color: `${value}.main` } }}
              />
            }
          />
        )
      })
    : null

  const handleSidebarToggleSidebar = () => {
     setShowPostContentDialog(true);
      //handleAddEventSidebarToggle()
    dispatch(handleSelectEvent(null))
  }

  if (renderFilters) {
    return (
      <Drawer
        open={leftSidebarOpen}
        onClose={handleLeftSidebarToggle}
        variant={mdAbove ? 'permanent' : 'temporary'}
        ModalProps={{
          disablePortal: true,
          disableAutoFocus: true,
          disableScrollLock: true,
          keepMounted: true // Better open performance on mobile.
        }}
        sx={{
          zIndex: 2,
          display: 'block',
          position: mdAbove ? 'static' : 'absolute',
          '& .MuiDrawer-paper': {
            borderRadius: 1,
            boxShadow: 'none',
            width: leftSidebarWidth,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            p: theme => theme.spacing(5),
            zIndex: mdAbove ? '2' : 'drawer',
            position: mdAbove ? 'static' : 'absolute'
          },
          '& .MuiBackdrop-root': {
            borderRadius: 1,
            position: 'absolute'
          }
        }}
      >
        <Button variant='contained' onClick={handleSidebarToggleSidebar}>
          Add Post
        </Button>

        <Typography variant='body2' sx={{ mt: 7, mb: 2.5, textTransform: 'uppercase' }}>
          Calendars
        </Typography>
        <FormControlLabel
          label='View All'
          sx={{ mr: 0, mb: 0.5 }}
          control={
            <Checkbox
              color='secondary'
              checked={store.selectedCalendars.length === colorsArr.length}
              onChange={e => dispatch(handleAllCalendars(e.target.checked))}
            />
          }
        />
        {renderFilters}
            <Autocomplete
                multiple
                options={availableChannels.map(((ch: any) => ({ label: ch.name, value: ch.id })))}
                //defaultValue={[top100Films[13]]}
                sx={{ width: 200, mt: 5 }}
                id='autocomplete-multiple-standard'
                getOptionLabel={option => (option.label)}
                onChange={(event, value: any) => {
                    console.log(value)
                    dispatch(handleChannelUpdate(value))
                }}
                renderInput={params => (
                    <TextField {...params} label='Channels' placeholder='Favorites' variant='standard' />
                )}
            />
      </Drawer>
    )
  } else {
    return null
  }
}

export default SidebarLeft
